import React from 'react'
import Lottie from 'lottie-react'
import animationData from 'phoenix/assets/animations/CheckAnimation.json'

const AnimatedCheckMark = (props: { size?: number }) => {
    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }
    return (
        <div>
            <Lottie
                {...defaultOptions}
                style={{
                    height: props.size || 100,
                    width: props.size || 100
                }}
            />
        </div>
    )
}

export default AnimatedCheckMark
